import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Unbekannter Fehler" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="rounded-2xl border border-red-500/30 bg-red-500/5 p-10 text-center">
          <p className="font-display text-2xl text-white mb-2">Etwas ist schiefgelaufen.</p>
          <p className="text-[#999] text-sm mb-6">{this.state.message}</p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-full bg-white text-[#050505] px-6 py-3 text-sm font-medium hover:bg-[#d1d5db] transition-colors"
          >
            Neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
